<template>
    <Dialog width="80%" :title="$t('pinChoseGoods')" ref="dialogRef" @ok="ok">
        <Form :model="searchModel" layout="inline" :options="searchOptions" :loading="loading" reset
            :submit="$t('search')" @submit="searchModel.pageNum = 1; search();" />
        <div class="coin-tip">{{ $t('pinCoinTip') }}</div>
        <Space flex align="flex-start">
            <div style="flex:1">
                <Table rowKey="commodityId" :page="searchModel" @pageChange="search" :loading="loading"
                    :rowSelection="leftSelection" :customRow="leftRow" class="pickable"
                    :data="poolList" :cols="{
                        commodityName: {
                            title: $t('pinCanApplyGoods'),
                            align: 'left'
                        }
                    }">
                    <template #commodityName="{ text, row }">
                        <div class="goods">
                            <img :src="fi(row.commodityImg)" width="100" height="100" alt="">
                            <div>
                                <h1>{{ text }}</h1>
                                <div>
                                    <Price :price="row.salsePrice" :size="18" color="black" />
                                    <span class="skus">{{ $t('pinSpecCount').replace('[n]', row.specList?.length || 0)
                                        }}</span>
                                    <em v-if="isStaged(row.commodityId)" class="staged">{{ $t('pinStaged') }}</em>
                                </div>
                            </div>
                        </div>
                    </template>
                </Table>
                <br>
                <AButton v-t="'addGoods'" type="primary" @click="move"></AButton>
                <span class="picked-tip" v-if="selectedGoods.length">
                    {{ $t('pinPickedCount').replace('[n]', selectedGoods.length) }}
                </span>
            </div>
            <div style="flex:1">
                <Table rowKey="commodityId"
                    :rowSelection="{ selectedRowKeys: checkedIds, onChange: keys => checkedIds = keys }"
                    :data="checkedGoodsList" :cols="{
                        commodityName: {
                            title: $t('checkedGoods'),
                            align: 'left'
                        }
                    }">
                    <template #commodityName="{ text, row }">
                        <div class="goods">
                            <img :src="fi(row.commodityImg)" width="100" height="100" alt="">
                            <div>
                                <h1>{{ text }}</h1>
                                <div>
                                    <Price :price="row.salsePrice" :size="18" color="black" />
                                    <span class="skus" :class="{ empty: !picked(row).length }">
                                        {{ filledLabel(row) }}
                                    </span>
                                    <a v-t="'pinSetPrice'" style="color:red;" href="javascript:;;"
                                        @click="detail(row)"></a>
                                </div>
                            </div>
                        </div>
                    </template>
                </Table>
                <br>
                <AButton v-t="'removeGoods'" type="primary" @click="removeChecked"></AButton>
            </div>
        </Space>
    </Dialog>
    <Dialog width="80%" :title="$t('pinSetSpecTitle')" ref="dfSpec" @ok="specOk">
        <Table rowKey="specId" :data="specList" :cols="{
            specName: $t('specification'),
            price: $t('pinSpecOriginPrice'),
            apply: $t('pinApplyThisSpec'),
            pinPrice: $t('pinPrice'),
            pinInventory: $t('pinInventory'),
            pinNumber: $t('pinNumber'),
            pinValidHour: $t('pinValidHour'),
            sortNo: $t('sort')
        }">
            <template #specName="{ text, row }">
                <div class="spec">
                    <span>{{ row.specId === 0 ? $t('pinAllSpecRow') : (text || $t('pinAllSpec')) }}</span>
                    <em v-if="row.applied" class="applied">{{ $t('pinAlreadyApplied') }}</em>
                </div>
            </template>
            <template #price="{ text }">
                <Price :price="text" :size="18" color="black" />
            </template>
            <template #apply="{ row }">
                <ACheckbox v-model:checked="row.apply" :disabled="row.applied"></ACheckbox>
            </template>
            <template #pinPrice="{ row }">
                <AInputNumber v-if="!row.applied" v-model:value="row.pinPrice" style="width:140px" :min="0.01"
                    :max="ceilingOf(row)" :precision="2" />
            </template>
            <template #pinInventory="{ row }">
                <AInputNumber v-if="!row.applied" v-model:value="row.pinInventory" style="width:120px" :min="-1"
                    :max="999999" :precision="0" />
            </template>
            <template #pinNumber="{ row }">
                <AInputNumber v-if="!row.applied" v-model:value="row.pinNumber" style="width:110px" :min="2" :max="20"
                    :precision="0" />
            </template>
            <template #pinValidHour="{ row }">
                <AInputNumber v-if="!row.applied" v-model:value="row.pinValidHour" style="width:110px" :min="1"
                    :max="168" :precision="0" />
            </template>
            <template #sortNo="{ row }">
                <AInputNumber v-if="!row.applied" v-model:value="row.sortNo" style="width:90px" :min="0" :precision="0" />
            </template>
        </Table>
        <div class="coin-tip">{{ $t('pinPriceRuleTip') }}</div>
    </Dialog>
</template>

<script>
export default {
    name: 'PinGoodsSelector'
}
</script>
<script setup>
// 拼团选品：左列本店可报名商品，右列待报名商品，逐规格填拼团价/库存/几人团/单团时长
import { computed, inject, nextTick, reactive, ref } from "vue";
import { message } from 'ant-design-vue';
import api from '@/api/shop';

const props = defineProps(['activityId', 'defaults']);
const emit = defineEmits(['apply']);
/**
 * 语言国际化对象
 */
const t = inject('t');
/**
 * 弹窗引用
 */
const dialogRef = ref();
/**
 * 规格设置弹窗引用
 */
const dfSpec = ref();
/**
 * loading
 */
const loading = ref(false);
/**
 * 搜索模型
 */
const searchModel = reactive({
    commodityName: '',
    pageNum: 1,
    pageSize: 10,
    total: 0
});
/**
 * 搜索表单配置项
 */
const searchOptions = computed(() => ({
    commodityName: {
        title: t('goodsName'),
        ph: t('searchGoods'),
        max: 50
    }
}));
/**
 * 可报名商品池
 */
const poolList = ref([]);
/**
 * 左列勾选暂存的商品
 */
const selectedGoods = reactive([]);
/**
 * 右列待报名商品
 */
const checkedGoodsList = ref([]);
/**
 * 右列勾选的 ids
 */
const checkedIds = ref([]);
/**
 * 当前编辑商品的规格
 */
const specList = ref([]);
/**
 * 当前编辑的商品
 */
const model = ref({});

defineExpose({
    clear: () => {
        checkedGoodsList.value = [];
        checkedIds.value = [];
        selectedGoods.splice(0);
    },
    show: async () => {
        dialogRef.value?.show();
        await nextTick();
        searchModel.commodityName = '';
        searchModel.pageNum = 1;
        search();
    },
    hide: () => dialogRef.value.hide()
});

/**
 * 拼团价上限：与后端 originPriceOf 同口径（有规格价取规格价，否则全规格最低价，再回落商品价）
 */
const ceilingOf = row => {
    const price = Number(row.price);
    if (price > 0) return price;
    const prices = specList.value.map(c => Number(c.price)).filter(c => c > 0);
    if (prices.length) return Math.min(...prices);
    return Number(model.value.salsePrice) || undefined;
};

/**
 * 某商品已勾选填价的规格数
 */
const picked = row => (row.specList || []).filter(c => c.apply && !c.applied);

/**
 * 右列的填写进度。按"全部规格一个价"报名的商品显示成 1/N 会让商家以为还有 N-1 个规格没填 ⇒ 直接显示那一档的名字
 */
const filledLabel = row => {
    const list = picked(row);
    if (list.some(c => c.specId === 0)) return t('pinAllSpecRow');
    return t('pinFilledCount').replace('[n]', list.length).replace('[m]', (row.specList || []).filter(c => c.specId > 0).length);
};

/**
 * 某商品是否已移入右列
 */
const isStaged = commodityId => checkedGoodsList.value.some(c => c.commodityId === commodityId);

/**
 * 勾选/取消一个商品（只认 commodityId，与当前在第几页无关）
 */
const toggleStage = (commodityId, on) => {
    const index = selectedGoods.findIndex(c => c.commodityId === commodityId);
    if (on) {
        if (index >= 0) return;
        const goods = poolList.value.find(c => c.commodityId === commodityId);
        goods && selectedGoods.push({ ...goods });
    }
    else {
        index >= 0 && selectedGoods.splice(index, 1);
    }
}

/**
 * 左列勾选配置。
 * ★这里刻意不用 onChange 结算：ant 在 dataSource 换页/重查时也会拿"被裁掉的键集"回调一次 onChange，
 *   而裁键只看当前页 ⇒ 上一页的暂存会被当成"用户取消了"整批冲掉（现网实测：换页后点"添加商品"什么都不动）。
 *   onSelect/onSelectAll 只在用户真实点击时触发，再加 preserveSelectedRowKeys 让跨页的键不被裁。
 */
const leftSelection = computed(() => ({
    selectedRowKeys: selectedGoods.map(c => c.commodityId),
    preserveSelectedRowKeys: true,
    /** ant 的 onSelect 是 (record, selected, ...)，与 onChange 的 (keys, rows) 顺序相反：写反了就是"点了没反应" */
    onSelect: (row, selected) => toggleStage(row.commodityId, selected),
    onSelectAll: (selected, rows, changeRows) => {
        for (const row of changeRows || rows || []) {
            toggleStage(row.commodityId, selected);
        }
    }
}));

/**
 * 整行可点：商品名/主图占了 95% 的行面积，只让 16px 的方框可点等于"点了没反应"
 */
const leftRow = row => ({
    onClick: event => {
        if (event.target.closest('.ant-checkbox-wrapper, .ant-checkbox, input, a, button')) return;
        toggleStage(row.commodityId, !selectedGoods.some(c => c.commodityId === row.commodityId));
    }
});

/**
 * 搜索可报名商品池
 */
const search = async () => {
    try {
        loading.value = true;
        const { total, data } = await api.pinCommodityPool({ ...searchModel, activityId: props.activityId });
        poolList.value = data || [];
        searchModel.total = total;
    } catch (error) { }
    loading.value = false;
}

/**
 * 移入待报名
 */
const move = () => {
    if (!selectedGoods.length) {
        message.warning(t('pinPickFirst'));
        return;
    }
    for (const item of selectedGoods) {
        if (!isStaged(item.commodityId)) {
            checkedGoodsList.value.push({ ...item, specList: (item.specList || []).map(c => ({ ...c })) });
        }
    }
    selectedGoods.splice(0, Infinity);
}

/**
 * 移出待报名
 */
const removeChecked = () => {
    for (const id of checkedIds.value) {
        const index = checkedGoodsList.value.findIndex(c => c.commodityId === id);
        index >= 0 && checkedGoodsList.value.splice(index, 1);
    }
    checkedIds.value = [];
}

/**
 * "全部规格同一个价"那一行（spec_id=0）。后端 resolvePin 在规格行没命中时回落到它，
 * 运营侧播种的报名行也全是 spec_id=0，而商品可以一个规格都没有——这一行是必填项的唯一出路，
 * 所以不能只留给"逐规格"两支。
 */
const allSpecRow = specs => {
    const prices = specs.map(c => Number(c.price)).filter(c => c > 0);
    const prior = (model.value.specList || []).find(c => c.specId === 0);
    return {
        specId: 0,
        specName: '',
        price: prices.length ? Math.min(...prices) : Number(model.value.salsePrice),
        applied: !!specs.length && specs.every(c => c.applied),
        apply: !!prior?.apply,
        pinPrice: prior?.pinPrice,
        pinInventory: prior?.pinInventory,
        pinNumber: prior?.pinNumber ?? props.defaults?.pinNumber,
        pinValidHour: prior?.pinValidHour ?? props.defaults?.pinValidHour,
        sortNo: prior?.sortNo ?? 0
    };
};

/**
 * 逐规格设置拼团价
 */
const detail = row => {
    model.value = row;
    const specs = (row.specList || []).map(c => ({
        ...c,
        apply: !!c.apply,
        pinPrice: c.pinPrice,
        pinInventory: c.pinInventory,
        pinNumber: c.pinNumber ?? props.defaults?.pinNumber,
        pinValidHour: c.pinValidHour ?? props.defaults?.pinValidHour,
        sortNo: c.sortNo ?? 0
    }));
    specList.value = [allSpecRow(specs), ...specs];
    dfSpec.value.show();
}

/**
 * 规格设置确定：校验后写回该商品
 */
const specOk = () => {
    const rows = specList.value.filter(c => c.apply && !c.applied);
    if (!rows.length) {
        message.warning(t('pinNoneChosen'));
        return;
    }
    /** 一条商品要么"全部规格按一个价"、要么逐规格，混着勾后端会存成两行、C 端读哪条取决于回落顺序 ⇒ 直接挡在提交前 */
    if (rows.length > 1 && rows.some(c => c.specId === 0)) {
        message.warning(t('pinSpecConflict'));
        return;
    }
    for (const row of rows) {
        const ceiling = ceilingOf(row);
        if (typeof row.pinPrice !== 'number' || row.pinPrice <= 0) {
            message.warning(t('pinPriceRequired'));
            return;
        }
        if (ceiling && row.pinPrice >= ceiling) {
            message.warning(t('pinPriceTooHigh').replace('[p]', ceiling));
            return;
        }
        if (typeof row.pinInventory !== 'number' || row.pinInventory < -1) {
            message.warning(t('pinInventoryRequired'));
            return;
        }
    }
    model.value.specList = specList.value.map(c => ({ ...c }));
    dfSpec.value.hide();
}

/**
 * 确定报名：把所有勾选项摊平成 items 交给父级提交
 */
const ok = () => {
    const items = [];
    for (const goods of checkedGoodsList.value) {
        for (const spec of picked(goods)) {
            items.push({
                commodityId: goods.commodityId,
                specId: spec.specId,
                pinPrice: spec.pinPrice,
                pinInventory: spec.pinInventory,
                pinNumber: spec.pinNumber,
                pinValidHour: spec.pinValidHour,
                sortNo: spec.sortNo
            });
        }
    }
    /** 移进右列但一个规格都没填的商品会被静默丢掉——那正是"我明明报了 5 个商品怎么只上了 2 个"的来源。先报它，否则全部未填时只会看到笼统的"请至少勾选一个规格" */
    const blank = checkedGoodsList.value.filter(c => !picked(c).length);
    if (blank.length) {
        message.warning(t('pinUnfilledBlock').replace('[n]', blank.length));
        return;
    }
    if (!items.length) {
        message.warning(t('pinNoneChosen'));
        return;
    }
    emit('apply', items);
}
</script>

<style lang="scss" scoped>
.goods {
    display: flex;
    gap: 10px;

    &>div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100px;
        flex: 1;

        h1 {
            font-size: 16px;
            margin: 0;
        }

        &>div {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 6px;

            :deep .ant-input-number-group-addon {
                background: transparent;
                border: none;
                color: rgb(231, 0, 0);
            }
        }
    }
}

.skus {
    color: #7f7f7f;
    white-space: nowrap;

    &.empty {
        color: #d9001b;
    }
}

.staged {
    color: #52c41a;
    font-style: normal;
    white-space: nowrap;
}

.picked-tip {
    color: #7f7f7f;
    margin-inline-start: 10px;
}

.pickable {
    :deep(.ant-table-tbody>tr.ant-table-row) {
        cursor: pointer;
    }
}

.spec {
    display: flex;
    align-items: center;
    gap: 8px;

    .applied {
        color: #d9001b;
        font-style: normal;
    }
}

.coin-tip {
    color: #7f7f7f;
    padding: 8px 0;
}
</style>
